const MANUAL = 1;
const AUTOMATIC = 2;
const ON_COMPLETION = 3;

export default {
  MANUAL,
  AUTOMATIC,
  ON_COMPLETION
};
